module.exports = __webpack_public_path__ + "static/media/img_coupon2.dc46eb44.png";